(() => {
  if (customElements.get('darluma-journal')) return;
  class DarlumaJournal extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      queueMicrotask(() => {
        if (!this.isConnected) return;
        if (this.dataset.mode === 'index') this.setupIndex();
        else this.setupArticle();
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.controller = null;
    }
    normalise(value) {
      return value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f\u064b-\u065f\u0670\u0640]/g, '').replace(/[أإآ]/g, 'ا').replace(/ى/g, 'ي').trim();
    }
    setupIndex() {
      const cards = [...this.querySelectorAll('[data-guide-card]')];
      const search = this.querySelector('[data-guide-search-input]');
      const filters = [...this.querySelectorAll('[data-guide-filter]')];
      const status = this.querySelector('[data-guide-status]');
      const empty = this.querySelector('[data-guide-empty]');
      let selected = '';
      const apply = () => {
        const words = this.normalise(search.value).split(/\s+/).filter(Boolean);
        let count = 0;
        cards.forEach(card => {
          const matchesTopic = !selected || card.dataset.guideTags.split('|').includes(selected);
          const text = this.normalise(card.dataset.guideSearch);
          const visible = matchesTopic && words.every(word => text.includes(word));
          card.hidden = !visible;
          if (visible) count++;
        });
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideFilter === selected)));
        status.textContent = `${count} ${this.dataset.resultsLabel}`;
        empty.hidden = count > 0;
      };
      this.querySelector('[data-guide-controls]').hidden = false;
      search.addEventListener('input', apply, {signal: this.signal});
      filters.forEach(button => button.addEventListener('click', () => { selected = button.dataset.guideFilter; apply(); }, {signal: this.signal}));
      this.querySelector('[data-guide-reset]').addEventListener('click', () => { selected = ''; search.value = ''; apply(); search.focus(); }, {signal: this.signal});
      apply();
    }
    setupArticle() {
      const toc = this.querySelector('.dl-article__toc');
      if (toc && matchMedia('(max-width:749px)').matches) toc.open = false;
      const links = [...this.querySelectorAll('[data-guide-anchor]')];
      this.querySelectorAll('[data-guide-anchor], [data-guide-top]').forEach(link => link.addEventListener('click', event => {
        const id = link.getAttribute('href').slice(1);
        const target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        history.replaceState(null, '', `#${id}`);
        target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
      }, {signal: this.signal}));
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const heading = entries.find(entry => entry.isIntersecting);
          if (!heading) return;
          links.forEach(link => {
            if (link.hash === `#${heading.target.id}`) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        }, {rootMargin: '-15% 0px -65% 0px'});
        this.querySelectorAll('[data-reading-heading]').forEach(heading => this.observer.observe(heading));
      }
      const content = this.querySelector('[data-reading-content]');
      const bar = this.querySelector('[data-reading-progress]');
      const update = () => {
        this.frame = null;
        const box = content.getBoundingClientRect();
        const travelled = innerHeight * 0.3 - box.top;
        const available = Math.max(1, box.height - innerHeight * 0.5);
        bar.style.setProperty('--dl-progress', String(Math.max(0, Math.min(1, travelled / available))));
      };
      const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(update); };
      window.addEventListener('scroll', schedule, {passive: true, signal: this.signal});
      window.addEventListener('resize', schedule, {passive: true, signal: this.signal});
      update();
    }
  }
  customElements.define('darluma-journal', DarlumaJournal);
})();
